import {
  isEnergyPitchFunnelSpecificVariant,
  isEnergyPitchLegacyVariant,
  isSocialProofMillionsVariant,
} from 'data/images/utils'
import type { ImagesDefinition } from 'types/images'

export const CHF01_IMAGES = {
  welcomeAgeBuckets: {
    fortyToFortyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/welcome-age-buckets/welcome_age_buckets_option_40_49.webp',
        '/images/chf01/welcome-age-buckets/welcome_age_buckets_option_40_49@2x.webp',
      ],
    },
    fiftyToFiftyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/welcome-age-buckets/welcome_age_buckets_option_50_59.webp',
        '/images/chf01/welcome-age-buckets/welcome_age_buckets_option_50_59@2x.webp',
      ],
    },
    sixtyToSixtyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/welcome-age-buckets/welcome_age_buckets_option_60_69.webp',
        '/images/chf01/welcome-age-buckets/welcome_age_buckets_option_60_69@2x.webp',
      ],
    },
    seventyPlus: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/welcome-age-buckets/welcome_age_buckets_option_70_plus.webp',
        '/images/chf01/welcome-age-buckets/welcome_age_buckets_option_70_plus@2x.webp',
      ],
    },
    heroBackground: {
      width: 651,
      height: 651,
      srcSet: [
        '/images/chf01/welcome-age-buckets/hero_background.webp',
        '/images/chf01/welcome-age-buckets/hero_background@2x.webp',
      ],
    },
    fortyToFortyNineList: {
      width: 96,
      height: 96,
      srcSet: [
        '/images/chf01/welcome-age-buckets/list/welcome_age_buckets_option_40_49.webp',
        '/images/chf01/welcome-age-buckets/list/welcome_age_buckets_option_40_49@2x.webp',
      ],
    },
    fiftyToFiftyNineList: {
      width: 96,
      height: 96,
      srcSet: [
        '/images/chf01/welcome-age-buckets/list/welcome_age_buckets_option_50_59.webp',
        '/images/chf01/welcome-age-buckets/list/welcome_age_buckets_option_50_59@2x.webp',
      ],
    },
    sixtyToSixtyNineList: {
      width: 96,
      height: 96,
      srcSet: [
        '/images/chf01/welcome-age-buckets/list/welcome_age_buckets_option_60_69.webp',
        '/images/chf01/welcome-age-buckets/list/welcome_age_buckets_option_60_69@2x.webp',
      ],
    },
    seventyPlusList: {
      width: 96,
      height: 96,
      srcSet: [
        '/images/chf01/welcome-age-buckets/list/welcome_age_buckets_option_70_plus.webp',
        '/images/chf01/welcome-age-buckets/list/welcome_age_buckets_option_70_plus@2x.webp',
      ],
    },
  },
  socialProofMillions: {
    pitch: {
      width: 370,
      height: 364,
      srcSet: [
        '/images/chf01/social_proof_millions.webp',
        '/images/chf01/social_proof_millions@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('default'),
    },
    group: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/chf01/social-proof-millions/group.webp',
        '/images/chf01/social-proof-millions/group@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('group'),
    },
  },
  experience: {
    question: {
      width: 369,
      height: 377,
      srcSet: [
        '/images/chf01/experience.webp',
        '/images/chf01/experience@2x.webp',
      ],
    },
    pitch: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/experience_pitch.webp',
        '/images/chf01/experience_pitch@2x.webp',
      ],
    },
  },
  mainGoal: {
    getToned: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chf01/main-goal/main_goal_option_get_toned.webp',
        '/images/chf01/main-goal/main_goal_option_get_toned@2x.webp',
      ],
    },
    improveFitness: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chf01/main-goal/main_goal_option_improve_fitness.webp',
        '/images/chf01/main-goal/main_goal_option_improve_fitness@2x.webp',
      ],
    },
    loseWeight: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chf01/main-goal/main_goal_option_lose_weight.webp',
        '/images/chf01/main-goal/main_goal_option_lose_weight@2x.webp',
      ],
    },
  },
  physicalBuild: {
    extended: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/physical-build/physical_build_option_extended.webp',
        '/images/chf01/physical-build/physical_build_option_extended@2x.webp',
      ],
    },
    fullfigured: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/physical-build/physical_build_option_fullfigured.webp',
        '/images/chf01/physical-build/physical_build_option_fullfigured@2x.webp',
      ],
    },
    midsized: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/physical-build/physical_build_option_midsized.webp',
        '/images/chf01/physical-build/physical_build_option_midsized@2x.webp',
      ],
    },
    slim: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/physical-build/physical_build_option_slim.webp',
        '/images/chf01/physical-build/physical_build_option_slim@2x.webp',
      ],
    },
  },
  bodyGoal: {
    thin: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/body-goal/body_goal_option_thin.webp',
        '/images/chf01/body-goal/body_goal_option_thin@2x.webp',
      ],
    },
    toned: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/body-goal/body_goal_option_toned.webp',
        '/images/chf01/body-goal/body_goal_option_toned@2x.webp',
      ],
    },
    curvy: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/body-goal/body_goal_option_curvy.webp',
        '/images/chf01/body-goal/body_goal_option_curvy@2x.webp',
      ],
    },
    average: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/body-goal/body_goal_option_average.webp',
        '/images/chf01/body-goal/body_goal_option_average@2x.webp',
      ],
    },
  },
  consistencyPitch: {
    forty: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/consistency-pitch/consistency_pitch_40.webp',
        '/images/chf01/consistency-pitch/consistency_pitch_40@2x.webp',
      ],
    },
    fifty: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/consistency-pitch/consistency_pitch_50.webp',
        '/images/chf01/consistency-pitch/consistency_pitch_50@2x.webp',
      ],
    },
    sixty: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/consistency-pitch/consistency_pitch_60.webp',
        '/images/chf01/consistency-pitch/consistency_pitch_60@2x.webp',
      ],
    },
    seventy: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/consistency-pitch/consistency_pitch_70.webp',
        '/images/chf01/consistency-pitch/consistency_pitch_70@2x.webp',
      ],
    },
    unknown: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/consistency-pitch/consistency_pitch_unknown.webp',
        '/images/chf01/consistency-pitch/consistency_pitch_unknown@2x.webp',
      ],
    },
  },
  flexibility: {
    low: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chf01/flexibility/flexibility_low.webp',
        '/images/chf01/flexibility/flexibility_low@2x.webp',
      ],
    },
    medium: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chf01/flexibility/flexibility_medium.webp',
        '/images/chf01/flexibility/flexibility_medium@2x.webp',
      ],
    },
    high: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chf01/flexibility/flexibility_high.webp',
        '/images/chf01/flexibility/flexibility_high@2x.webp',
      ],
    },
  },
  posture: {
    pitch: {
      width: 370,
      height: 234,
      srcSet: [
        '/images/chf01/posture_pitch.webp',
        '/images/chf01/posture_pitch@2x.webp',
      ],
    },
  },
  problemAreas: {
    belly: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/chf01/problem-areas/problem_areas_option_belly.webp',
        '/images/chf01/problem-areas/problem_areas_option_belly@2x.webp',
      ],
    },
    butt: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/chf01/problem-areas/problem_areas_option_butt.webp',
        '/images/chf01/problem-areas/problem_areas_option_butt@2x.webp',
      ],
    },
    chest: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/chf01/problem-areas/problem_areas_option_chest.webp',
        '/images/chf01/problem-areas/problem_areas_option_chest@2x.webp',
      ],
    },
    legs: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/chf01/problem-areas/problem_areas_option_legs.webp',
        '/images/chf01/problem-areas/problem_areas_option_legs@2x.webp',
      ],
    },
  },
  struggle: {
    back: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/struggle/struggle_option_back.webp',
        '/images/chf01/struggle/struggle_option_back@2x.webp',
      ],
    },
    knees: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/struggle/struggle_option_knees.webp',
        '/images/chf01/struggle/struggle_option_knees@2x.webp',
      ],
    },
    none: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chf01/struggle/struggle_option_none.webp',
        '/images/chf01/struggle/struggle_option_none@2x.webp',
      ],
    },
  },
  bodyTypePitch: {
    endomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/chf01/body-type-pitch/body_type_pitch_endomorph.webp',
        '/images/chf01/body-type-pitch/body_type_pitch_endomorph@2x.webp',
      ],
    },
    mesomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/chf01/body-type-pitch/body_type_pitch_mesomorph.webp',
        '/images/chf01/body-type-pitch/body_type_pitch_mesomorph@2x.webp',
      ],
    },
    ectomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/chf01/body-type-pitch/body_type_pitch_ectomorph.webp',
        '/images/chf01/body-type-pitch/body_type_pitch_ectomorph@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/struggle-pitch/struggle_pitch_knees.webp',
        '/images/chf01/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/struggle-pitch/struggle_pitch_back.webp',
        '/images/chf01/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/struggle-pitch/struggle_pitch_both.webp',
        '/images/chf01/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
  stairsCardio: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/chf01/stairs_cardio.webp',
        '/images/chf01/stairs_cardio@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/chf01/how_often_exercise.webp',
        '/images/chf01/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/chf01/how_often_walks.webp',
        '/images/chf01/how_often_walks@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/chf01/big-results-pitch/big_results_pitch_01.webp',
        '/images/chf01/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
    },
    second: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/chf01/big-results-pitch/big_results_pitch_02.webp',
        '/images/chf01/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
    },
    third: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/chf01/big-results-pitch/big_results_pitch_03.webp',
        '/images/chf01/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
    },
  },
  energyPitch: {
    group: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/energy-pitch/group.webp',
        '/images/chf01/energy-pitch/group@2x.webp',
      ],
      prefetchCondition: isEnergyPitchLegacyVariant,
    },
    person: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/energy-pitch/person.webp',
        '/images/chf01/energy-pitch/person@2x.webp',
      ],
      prefetchCondition: isEnergyPitchFunnelSpecificVariant,
    },
  },
  waterIntake: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/water_intake.webp',
        '/images/chf01/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/sleep_duration.webp',
        '/images/chf01/sleep_duration@2x.webp',
      ],
    },
  },
  timeBreakfast: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/time_breakfast.webp',
        '/images/chf01/time_breakfast@2x.webp',
      ],
    },
  },
  timeLunch: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/time_lunch.webp',
        '/images/chf01/time_lunch@2x.webp',
      ],
    },
  },
  timeDinner: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chf01/time_dinner.webp',
        '/images/chf01/time_dinner@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/chf01/wellness-profile/wellness_profile_extended.webp',
        '/images/chf01/wellness-profile/wellness_profile_extended@2x.webp',
      ],
    },
    fullFigured: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/chf01/wellness-profile/wellness_profile_fullfigured.webp',
        '/images/chf01/wellness-profile/wellness_profile_fullfigured@2x.webp',
      ],
    },
    midSized: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/chf01/wellness-profile/wellness_profile_midsized.webp',
        '/images/chf01/wellness-profile/wellness_profile_midsized@2x.webp',
      ],
    },
    slim: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/chf01/wellness-profile/wellness_profile_slim.webp',
        '/images/chf01/wellness-profile/wellness_profile_slim@2x.webp',
      ],
    },
  },
  subscription: {
    realisticBeforeExtended: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_before_extended.webp',
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_before_extended@2x.webp',
      ],
    },
    realisticBeforeFullfigured: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_before_fullfigured.webp',
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_before_fullfigured@2x.webp',
      ],
    },
    realisticBeforeMidsized: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_before_midsized.webp',
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_before_midsized@2x.webp',
      ],
    },
    realisticBeforeSlim: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_before_slim.webp',
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_before_slim@2x.webp',
      ],
    },
    realisticAfterThin: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_after_thin.webp',
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_after_thin@2x.webp',
      ],
    },
    realisticAfterToned: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_after_toned.webp',
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_after_toned@2x.webp',
      ],
    },
    realisticAfterCurvy: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_after_curvy.webp',
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_after_curvy@2x.webp',
      ],
    },
    realisticAfterAverage: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_after_average.webp',
        '/images/chf01/subscription/goal-body/realistic/paywall_comparison_after_average@2x.webp',
      ],
    },
  },
} satisfies ImagesDefinition
